// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2GF08","resendInfoText":"OnGoingPaymentBox_resendInfoText__HX5Kz"};